




























import { defineComponent, ref } from "@nuxtjs/composition-api";
import PBHelper from "~/components/PageBuilder/utils/helper";
import PBComponent from "~/components/PageBuilder/utils/component";
const { loadAsyncComponent } = PBComponent();

export default defineComponent({
  name: "LayoutColumns",
  components: {
    ...loadAsyncComponent(),
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    node: {
      type: String,
      default: "div",
    },
    attr: {
      type: Object,
      default: () => {},
    },
    children: {
      type: Array,
      default: () => [],
    },
    dynamicBlocks: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const { getComponentName } = PBHelper();
    const columnLines = ref([]);
    const getColumns = (columnLine) => columnLine.child;
    const getChildComponents = (column) => column.child;

    const pb = {children: props.children};
    columnLines.value = pb.children;

    return {
      columnLines,
      getColumns,
      getComponentName,
      getChildComponents,
    };
  },
});
